'use client' // Error components must be Client Components
import { useEffect } from 'react'
import { cookie, DY_COOKIE_SESSION } from '@/utils'
import { useSession } from '@/hooks'
// import Link from 'next/link'

export default function Error({ error, reset }: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const { setUser } = useSession()

  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error)
  }, [error])

  useEffect(() => {
    setUser(null)
    cookie.remove(DY_COOKIE_SESSION)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className='global-err'>
      <hgroup>
        <h1>Something went wrong</h1>
        <p>Go back <a href={`https://${process.env.NEXT_PUBLIC_PROJECT_HOSTNAME}`}>homepage</a> or<button
          onClick={
            // Attempt to recover by trying to re-render the segment
            () => reset()
          }
        >try again</button>.</p>
      </hgroup>
    </div>
  )
}
